// eslint-disable-next-line import/no-amd
define([
    '../../../utils/Globals',
    'jquery',
    'underscore',
    '../../app/models/MabinsoModel',
    './ReportPropertyCollection',
    '../../../utils/FormMessage'
], (Globals, $, _, MabinsoModel, ReportPropertyCollection, FormMessage) => {
    const ReportModel = MabinsoModel.extend({
        urlRoot: Globals.baseUrl + 'reports/report',
        urlUpload() {
            return Globals.baseUrl + 'reports/uploadReport';
        },
        defaults: {
            name: ''
        },
        getName() {
            const name = this.get('name');
            return _.toName(name);
        },
        initialize() {
        },
        uploadReport(options) {
            const model = this;
            if (model.form != null) {
                if (_.isUndefined(model.validate())) {
                    console.log(model.urlUpload());
                    model.form.attr('action', model.urlUpload());
                    model.form.ajaxForm({
                        url: model.urlUpload(),
                        data: options.data,
                        dataType: 'json',
                        success(data) {
                            console.log('success');
                            const formMessage = new FormMessage(data);
                            if (_.isFunction(options.success)) {
                                options.success(formMessage);
                            }
                        }
                    });
                    model.form.submit();
                }
            }
        },
        fetchProperties(options) {
            const model = this;
            const properties = new ReportPropertyCollection();
            if (!_.isUndefined(options.url)) {
                properties.url = Globals.baseUrl + options.url;
            }
            properties.fetch({
                data: (_.isUndefined(options.data) ? { report_id: model.id } : options.data),
                success() {
                    model.set('properties', properties);
                    if (_.isFunction(options.success)) {
                        options.success(properties);
                    }
                }
            });
        }
    }, {
        deleteItems(options) {
            console.log(options.items);
            $.ajax({
                url: Globals.baseUrl + 'reports/deleteItems',
                data: { ids: options.items },
                traditional: true,
                type: 'POST',
                dataType: 'JSON',
                success(data) {
                    if (_.isFunction(options.success)) {
                        options.success(data);
                    }
                }
            });
        }
    });
    return ReportModel;
});



// WEBPACK FOOTER //
// ./src/components/report/models/ReportModel.js